var map = {
	"./frontend/1x2FB.vue": 7259,
	"./frontend/2d3dPage.vue": 2944,
	"./frontend/AndroidGuide.vue": 594,
	"./frontend/BetslipHistory.vue": 3650,
	"./frontend/BodyFB.vue": 3301,
	"./frontend/CardGamePage.vue": 7106,
	"./frontend/ContactUs.vue": 3824,
	"./frontend/CorrectScore.vue": 4881,
	"./frontend/DataTable.vue": 818,
	"./frontend/Deposit.vue": 5279,
	"./frontend/FishingPage.vue": 8140,
	"./frontend/FootballPage.vue": 221,
	"./frontend/History.vue": 2651,
	"./frontend/Home.vue": 690,
	"./frontend/IOSGuide.vue": 9210,
	"./frontend/Iframe.vue": 1525,
	"./frontend/Index.vue": 6962,
	"./frontend/Live.vue": 7229,
	"./frontend/LiveScore.vue": 5634,
	"./frontend/MainMenu.vue": 7015,
	"./frontend/MaungFB.vue": 9556,
	"./frontend/Setting.vue": 104,
	"./frontend/SlotPage.vue": 3636,
	"./frontend/VideoLink.vue": 2201,
	"./frontend/Withdraw.vue": 3640,
	"./frontend/auth/Login.vue": 9464,
	"./frontend/auth/Register.vue": 5795,
	"./frontend/auth/Registerss.vue": 2601,
	"./frontend/auth/Rule.vue": 524,
	"./frontend/auth/Verify.vue": 9061,
	"./frontend/components/AccountSelect.vue": 2608,
	"./frontend/components/CorrectScoreCard.vue": 6823,
	"./frontend/components/DataTable.vue": 7555,
	"./frontend/components/FBPreviewVoucher.vue": 9111,
	"./frontend/components/FBVoucher.vue": 570,
	"./frontend/components/FootballTeamCard.vue": 6659,
	"./frontend/components/GroupBox.vue": 1965,
	"./frontend/components/InputSelectDrawModal.vue": 2865,
	"./frontend/components/NormalBox.vue": 6251,
	"./frontend/components/PreviewVoucher.vue": 9411,
	"./frontend/components/RealCorrectScore.vue": 3922,
	"./frontend/components/SideNav.vue": 1604,
	"./frontend/components/Table.vue": 4007,
	"./frontend/components/ThreedGroupBox.vue": 5327,
	"./frontend/components/TwoDSelect.vue": 4692,
	"./frontend/components/Voucher.vue": 6593,
	"./frontend/normal-user/2d/2d.vue": 7262,
	"./frontend/normal-user/2d/ClosedDays.vue": 1512,
	"./frontend/normal-user/2d/Home.vue": 2169,
	"./frontend/normal-user/2d/Winner.vue": 6877,
	"./frontend/normal-user/3d/3d.vue": 9818,
	"./frontend/normal-user/3d/Home.vue": 2656,
	"./frontend/normal-user/DreamBooks.vue": 156,
	"./frontend/normal-user/Index.vue": 5531,
	"./frontend/normal-user/bugyee/Room.vue": 8636,
	"./frontend/normal-user/game/Card.vue": 2964,
	"./frontend/normal-user/game/Fishing.vue": 9827,
	"./frontend/normal-user/game/Game.vue": 9621,
	"./frontend/normal-user/game/Slot.vue": 6770,
	"./frontend/normal-user/shankomee/Room.vue": 4199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7057;